import createReactComponent from '../createReactComponent';
export default createReactComponent('slash', 'IconSlash', [
  ['path', { d: 'M17 5l-10 14', key: 'svg-0' }],
]);
